import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <main className="not-found-page">
            <div className="not-found-grid" aria-hidden="true" />
            <div className="not-found-orbit not-found-orbit-one" aria-hidden="true" />
            <div className="not-found-orbit not-found-orbit-two" aria-hidden="true" />

            <section className="not-found-content">
                <span className="section-kicker">ROUTE NOT FOUND</span>
                <div className="not-found-code" aria-label="Error 404">
                    <span>4</span>
                    <i aria-hidden="true">
                        <svg viewBox="0 0 100 100" role="img">
                            <path d="M16 50h68M50 16v68M26 26l48 48M74 26 26 74" />
                            <circle cx="50" cy="50" r="36" />
                            <circle cx="50" cy="50" r="12" />
                        </svg>
                    </i>
                    <span>4</span>
                </div>
                <h1>This shipment took a <em>wrong turn.</em></h1>
                <p>
                    The page you’re looking for doesn’t exist or may have moved.
                    Let’s get you back on the right route.
                </p>
                <div className="not-found-actions">
                    <Link className="btn btn-primary" to="/">Back to home <span>↗</span></Link>
                    <Link className="not-found-secondary" to="/CalQuote">Get a quote →</Link>
                </div>
            </section>
        </main>
    );
};

export default NotFound;